module.exports = __webpack_public_path__ + "static/media/logo-dark.38fe0bfd.png";